import React, { useState, useEffect, useRef  } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { Messages } from 'primereact/messages';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { useAuth } from '../contexts/AuthContext.js';
import Container from 'react-bootstrap/Container';
import { Toast } from 'primereact/toast';
import { ScrollTop } from 'primereact/scrolltop';
import useStatusPageScript from '../hooks/useStatusPageScript.js';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ProgressBar } from 'primereact/progressbar';
import { InputSwitch } from 'primereact/inputswitch';
import { InputTextarea } from 'primereact/inputtextarea';
import '../config.js'
import { Dialog } from 'primereact/dialog';
import AccessState from './AccessState';
import usePageAccessRedirect from '../hooks/usePageAccessRedirect';

const ReplacementTiles = () => {
  // Load the status page script
  useStatusPageScript();
  
  const { locationName, locationId } = useParams();
  const [replacementTiles, setReplacementTiles] = useState([]);
  const [, setReplacementTilesShow] = useState([]);
  const navigate = useNavigate();
  const [rowSelectionModel, setRowSelectionModel] = useState();
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    tile: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    gate: { value: null, matchMode: FilterMatchMode.STARTS_WITH},
  });
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [loading, setLoading] = useState(true);
  const msgs = useRef(null);
  const [, setCreateVisible] = useState(false);
  const [poNumber, setPoNumber] = useState('');
  const [poValue, setPoValue] = useState('');
  const [contactName, setContactName] = useState('');
  const [deliveryAddress, setDeliveryAddress] = useState('');
  const [sendUpdaterTile, setSendUpdaterTile] = useState(false);

  const toastBC = useRef(null);
  const [createLoading, setCreateLoading] = useState(false);
  const [emails, setEmails] = useState('');
  const [showHelp, setShowHelp] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [editOriginalTile, setEditOriginalTile] = useState(null);
  const [editRowData, setEditRowData] = useState(null);
  const { accessIssue, clearAccessIssue, handleAccessError } = usePageAccessRedirect({
    deniedTitle: 'Replacement Tiles Access Denied',
    deniedMessage: 'You do not have permission to view or manage replacement tiles for this location.',
  });



  const op = useRef(null);
  const dt = useRef(null);

  const getErrorDetail = (error, fallbackMessage) => {
    const responseData = error && error.response ? error.response.data : null;

    if (typeof responseData === 'string' && responseData.trim() !== '') {
      return responseData;
    }

    if (responseData && typeof responseData === 'object') {
      if (typeof responseData.title === 'string' && responseData.title.trim() !== '') {
        const validationErrors = responseData.errors && typeof responseData.errors === 'object'
          ? Object.values(responseData.errors).flat().filter((message) => typeof message === 'string' && message.trim() !== '')
          : [];

        if (validationErrors.length > 0) {
          return `${responseData.title}: ${validationErrors.join(' ')}`;
        }

        return responseData.title;
      }

      if (typeof responseData.detail === 'string' && responseData.detail.trim() !== '') {
        return responseData.detail;
      }
    }

    return (error && error.message) || fallbackMessage;
  };


  useEffect(() => {
    const fetchReplacementTiles = async () => {
      await getReplacementTiles();
    };

    fetchReplacementTiles();

    let _filters = JSON.parse(localStorage.getItem('replacementTilesFilters'));
    if (_filters) {
      setFilters(_filters);
      setGlobalFilterValue(_filters.global.value);
    }
  }, [locationId, locationName]);

  useEffect(() => {

    // updateAccessPoint();
  }, []);

  const getReplacementTiles = async () => {
    try {
      clearAccessIssue();
      setLoading(true);
      setReplacementTiles([]);
      const token = localStorage.getItem('token');
      let header = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      console.log("get replacement tiles " + locationName + " " + locationId);
      const response = await axios.get(global.config.url + `/accesspoints/replacementtiles/${locationId}`, header);
        setReplacementTiles(response.data);
        
        const ap = [...response.data];
        // setAccessPointsShow(ap.sort((a, b) => (a.tile < b.tile) ? 1 : -1));
        setReplacementTilesShow(ap);
        setLoading(false);
    } catch (error) {
      if (handleAccessError(error)) {
          setLoading(false);
        } else if (error.response && error.response.status === 500) {
          msgs.current.show({ severity: 'error', summary: '', detail: 'Internal server error occurred.' });
        } else {
          console.error('Error fetching access points:', error);
          setLoading(false);
          msgs.current.show({ severity: 'error', summary: '', detail: getErrorDetail(error, 'Error fetching access points') });
        }
      }
  };

  if (accessIssue) {
    return <AccessState {...accessIssue} />;
  }

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters['global'].value = value;

    localStorage.setItem('replacementTilesFilters', JSON.stringify(_filters));

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const openEditDialog = (rowData) => {
    setEditOriginalTile(rowData);
    setEditRowData({
      ...rowData,
      size: rowData && rowData.size ? rowData.size : '',
      colour: rowData && rowData.colour ? rowData.colour : '',
      checkIn: Boolean(rowData && rowData.checkIn),
      type: rowData && rowData.type ? rowData.type : '',
      comments: rowData && rowData.comments ? rowData.comments : '',
      scanType: rowData && rowData.scanType ? rowData.scanType : '',
      quantity: Number.isFinite(Number(rowData && rowData.quantity)) ? Number(rowData.quantity) : 0,
    });
    setShowEditDialog(true);
  };

  const closeEditDialog = () => {
    setShowEditDialog(false);
    setEditOriginalTile(null);
    setEditRowData(null);
  };

  const saveEditedRow = () => {
    if (editOriginalTile === null || editRowData === null) {
      return;
    }

    const editIndex = replacementTiles.indexOf(editOriginalTile);
    if (editIndex < 0) {
      msgs.current.show({ severity: 'error', summary: '', detail: 'The replacement tile could not be found. Refresh the list and try again.' });
      closeEditDialog();
      return;
    }

    const nextTiles = [...replacementTiles];
    nextTiles[editIndex] = editRowData;
    setReplacementTiles(nextTiles);
    closeEditDialog();
  };

  const updateEditField = (field, value) => {
    setEditRowData((current) => {
      if (current === null) {
        return current;
      }

      return {
        ...current,
        [field]: value,
      };
    });
  };

  const editBodyTemplate = (rowData, options) => {
    return (
      <Button
        icon="pi pi-pencil"
        className="p-button-text"
        onClick={() => openEditDialog(rowData)}
        tooltip="Edit replacement tile"
        tooltipOptions={{ position: 'bottom' }}
      />
    );
  };

  const editDialogFooter = (
    <div className='flex justify-content-center mb-3'>
      <Button label="Cancel" icon="pi pi-times" className="p-button-warning" onClick={closeEditDialog} />
      <Button label="Save" icon="pi pi-check" className="p-button-success ml-3" onClick={saveEditedRow} />
    </div>
  );




  const startContent = (
    <React.Fragment>
      <div>
        {/* <Button onClick={() => getLogs()} label="Get Access Logs" icon="pi pi-file" className="p-button ml-3 mb-3" tooltip="Get access logs for this access point" tooltipOptions={{position:"bottom"}}/> */}
      </div>
        {/* <Button onClick={() => getEvents()} label="Get Events" icon="pi pi-file" className="p-button-warning mx-5" tooltip="Get events for this access point" tooltipOptions={{position:"bottom"}}/> */}
        {/* <Button onClick={() => getExtraInfo()} label="Extra Info" icon="pi pi-info-circle" className="p-button-info" tooltip="Get extra information for this access point" tooltipOptions={{position:"bottom"}}/> */}
    </React.Fragment>
);


const filterContent = (
    <span className="p-input-icon-left mb-3 ml-3">
      <i className="pi pi-search" />
      <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Filter by relay, tile, gate or client name" tooltip="Start typing a relay, tile, gate or client name" tooltipOptions={{position: "bottom"}}  />
    </span>
);

const clearFilter = () => {

  let _filters = { ...filters };
  _filters['global'].value = null;
  setFilters(_filters);
  setGlobalFilterValue('');
  localStorage.removeItem('replacementTilesFilters');
};

// const footerContent = (
//   <div>
//       <Button label="No" icon="pi pi-times" onClick={() => cancelNewAP(false)} className="p-button-text" />
//       <Button label="Yes" icon="pi pi-check" onClick={() => confirm(true)} autoFocus />
//   </div>
// );

  const createReplacementOrder = async () => {
    try {
      setCreateLoading(true);
      const token = localStorage.getItem('token');
      var axiosConfig = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      if(emails !== ''){
        //check emails format
        const emailArray = emails.split(/[,;]/).map(email => email.trim());
        for(const email of emailArray){
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if(!emailRegex.test(email)){
            setCreateLoading(false);
            msgs.current.show({severity: 'error', summary: '', detail: `Invalid email format: ${email}`});
            return;
          }
        }
      }
      let body = {
        poNumber: poNumber,
        poValue: poValue,
        contactName: contactName,
        deliveryAddress: deliveryAddress,
        sendUpdaterTile: sendUpdaterTile,
        tiles: replacementTiles,
        locationId: locationId,
        Emails: emails
      }
      const response = await axios.post(global.config.url + `/orders/replacementorder`, body, axiosConfig);
      if(response.status === 200){
        setCreateLoading(false);
        setCreateVisible(false);
        setPoValue('');
        setPoNumber('');
        setContactName('');
        setDeliveryAddress(''); 
        setSendUpdaterTile(false);
        setEmails('');
        msgs.current.show({severity: 'success', summary: '', detail: 'Replacement order created successfully.'});
        // navigate('/locations/' + locationName + '/' + locationId);
      }
      else{
        setCreateLoading(false);
        msgs.current.show({severity: 'error', summary: '', detail: 'Error creating replacement order.'});
      }
    } catch (error) {
      setCreateLoading(false);
      console.error('Error creating replacement order:', error);
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to create replacement orders for this location.' })) {
        return;
      }
      else if(error.response && error.response.status === 500){
        msgs.current.show({severity: 'error', summary: '', detail: 'Internal server error occurred.'});
      }
      else{
        console.error('Error creating replacement order:', error);
        msgs.current.show({severity: 'error', summary: '', detail: getErrorDetail(error, 'Error creating replacement order')});
      }
    }
  }

  const progressbar = (        
    <div className="card mt-3">
        <ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>
    </div>);

    const goBack = () => {
  
      localStorage.removeItem('replacementTilesFilters');
      navigate(-1);
    }

  return (
      <Container fluid className ="justify-content-md-center mt-5">
        <div className="flex justify-content-center mt-3">
          <Container className="flex align-content-center flex-wrap">
            
            <Button link icon="pi pi-arrow-left" onClick={() => goBack()} className='flex mb-3'/> 
            <h4 className='flex mt-2 mb-3 ml-3'>Access points for '{locationName}'</h4> 
            <div>
            {filterContent}
            <Button icon="pi pi-times" className="p-button-text mb-3" onClick={() => clearFilter()} tooltip="Clear filter" tooltipOptions={{position: "bottom"}}/>
            <Button icon="pi pi-refresh" className="p-button-text mb-3" onClick={() => getReplacementTiles()} disabled={loading} tooltip="Refresh access points" tooltipOptions={{position: "bottom"}}/>
            <Button icon="pi pi-question" className="p-button-text mb-3" onClick={() => setShowHelp(true)} tooltip="Help" tooltipOptions={{position: "bottom"}}/>
            {/* <Button icon="pi pi-copy" className='p-button-secondary mr-3 ml-2 mb-3' onClick={(e) => setCopyVisible(true)} disabled={loading} rounded tooltip="Show access points in copy format" tooltipOptions={{position: "bottom"}}/>
            <Button icon="pi pi-plus" className="p-button-success mb-3" rounded loading={createLoading} disabled={loading} onClick={() => createAP()} tooltip="Create new access point" tooltipOptions={{position: "bottom"}} />
            <Button icon="pi pi-trash" className="p-button-danger mx-3 mb-3" rounded loading={deleteLoading} disabled={loading} onClick={() => confirm(false)} tooltip="Delete selected access point" tooltipOptions={{position: "bottom"}} />
            <Button type="button" icon="pi pi-file-export" className='mb-3' rounded disabled={loading} onClick={() => exportCSV(false)} tooltip="Download as csv" tooltipOptions={{position: "bottom"}} />
            <Button icon="pi pi-qrcode" className='p-button-help is-light mx-3 mb-3' rounded disabled={!islocation || loading}  onClick={() => sendQRCodes()} tooltip="Send QR codes for all access points in this location" tooltipOptions={{position: "bottom"}} /> */}
            </div>

          </Container>
          </div>

        <Messages ref={msgs} />
        <Toast ref={toastBC} position="top-center" />
        {loading && progressbar}
          <div>
            <Container className="flex align-content-center flex-wrap">
              <div>
                <div className="flex p-float-label mt-4">
                  <InputText
                      id="ponumber"
                      name="ponumber"
                      value={poNumber}
                      onChange={(e) => setPoNumber(e.target.value)}
                  />
                  <label htmlFor="input_relay">PONumber</label>
                </div>
                <div className="flex p-float-label mt-2 mr-3">
                  <InputText
                      id="gate"
                      name="gate"
                      value={poValue}
                      onChange={(e) => setPoValue(e.target.value)}
                  />
                  <label htmlFor="input_gate">POValue</label>
                </div>
                <div className="flex border-1 border-300 border-round p-0.5 mt-2 mr-3">
                  <p className='ml-2 mr-2 mt-2'><label>Send Updater Tile</label></p>
                  <InputSwitch id="updaterTile" name="updaterTile" className='mt-2' checked={sendUpdaterTile} onChange={(e) => setSendUpdaterTile(e.value)}/>

                </div>
              </div>
              <div>

                <div className="flex p-float-label my-4 mr-3">
                  <InputTextarea
                      id="deliveryaddress"
                      name="deliveryaddress"
                      value={deliveryAddress}
                      onChange={(e) => setDeliveryAddress(e.target.value)}
                      rows={6}
                      cols={40}
                      autoResize
                  />
                  <label htmlFor="input_deliveryaddress">Delivery Address</label>
                </div>

                <div className='flex p-float-label mt-4 mr-3'>
                </div>
              </div>
              <div className=''>
                <div className="flex p-float-label my-4 mr-3">
                  <InputText
                      id="contactname"
                      name="contactname"
                      value={contactName}
                      onChange={(e) => setContactName(e.target.value)}
                      minWidth={500}
                  />
                  <label htmlFor="input_contactname">Contact Name</label>
                  <Button label="" rounded icon="pi pi-save" className="p-button-success ml-4" onClick={createReplacementOrder} loading={createLoading} disabled={createLoading || poNumber === '' || poValue === '' || contactName === '' || deliveryAddress === '' || replacementTiles.length === 0} />

                </div>
                <div className="flex p-float-label my-4 mr-3">
                  <InputTextarea
                      id="emails"
                      name="emails"
                      value={emails}
                      onChange={(e) => setEmails(e.target.value)}
                      rows={3}
                      cols={35}
                      autoResize
                  />
                  <label htmlFor="input_emails">Emails</label>
                </div>


              </div>
            </Container>
          </div>
          <div>
            <Dialog visible={showHelp} style={{ width: '50vw' }} header="Help" modal className="p-fluid" onHide={() => setShowHelp(false)}>
              <p className='mt-3'>Type: It is either Tile, AccessPod, TilePodMini, TilePodMini with Backboard or TilePod</p>
              <p className='mt-3'>ScanType: It is either Access, Member Information or Check-in</p>
              <p className='mt-3'>Tile sizes: 55x61mm; 65x72mm; 85x94mm; 110x122mm; A4; A5; A3; Tile Wedge; Round; Standard</p>
            </Dialog>
            <Dialog
              visible={showEditDialog}
              style={{ width: '40rem' }}
              header={editRowData ? `Edit ${editRowData.tile || 'Replacement Tile'}` : 'Edit Replacement Tile'}
              modal
              className="p-fluid"
              onHide={closeEditDialog}
              footer={editDialogFooter}
            >
              {editRowData !== null && (
                <Container>
                  <div className="grid">
                    <div className="col-12 md:col-6">
                      <div className="flex p-float-label mt-4">
                        <InputText id="edit-size" value={editRowData.size} onChange={(e) => updateEditField('size', e.target.value)} />
                        <label htmlFor="edit-size">Size</label>
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div className="flex p-float-label mt-4">
                        <InputText id="edit-colour" value={editRowData.colour} onChange={(e) => updateEditField('colour', e.target.value)} />
                        <label htmlFor="edit-colour">Colour</label>
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div className="flex border-1 border-300 border-round p-2 mt-4 align-items-center justify-content-between">
                        <label htmlFor="edit-checkin" className="mb-0">Check In</label>
                        <InputSwitch id="edit-checkin" checked={Boolean(editRowData.checkIn)} onChange={(e) => updateEditField('checkIn', Boolean(e.value))} />
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div className="flex p-float-label mt-4">
                        <InputText id="edit-type" value={editRowData.type} onChange={(e) => updateEditField('type', e.target.value)} />
                        <label htmlFor="edit-type">Type</label>
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div className="flex p-float-label mt-4">
                        <InputText id="edit-scantype" value={editRowData.scanType} onChange={(e) => updateEditField('scanType', e.target.value)} />
                        <label htmlFor="edit-scantype">Scan Type</label>
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div className="flex p-float-label mt-4">
                        <Dropdown
                          inputId="edit-quantity"
                          value={editRowData.quantity}
                          options={[0, 1, 2, 3, 4, 5].map((quantity) => ({ label: quantity, value: quantity }))}
                          optionLabel="label"
                          optionValue="value"
                          onChange={(e) => updateEditField('quantity', e.value)}
                          placeholder="Select a Quantity"
                        />
                        <label htmlFor="edit-quantity">Quantity</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="flex p-float-label mt-4">
                        <InputTextarea
                          id="edit-comments"
                          value={editRowData.comments}
                          onChange={(e) => updateEditField('comments', e.target.value)}
                          rows={4}
                          autoResize
                        />
                        <label htmlFor="edit-comments">Comments</label>
                      </div>
                    </div>
                  </div>
                </Container>
              )}
            </Dialog>
          </div>
        <div className='justify-content-md-center mt-3'>

          <DataTable value={replacementTiles} selectionMode={'single'} selection={rowSelectionModel} onSelectionChange={(e) => setRowSelectionModel(e.value)} 
          dataKey="id" style={{ width: '100%' }}
          filters={filters} ref={dt} globalFilterFields={['relay', 'tile', 'gate', 'client.name', 'location.name']} 
          emptyMessage={loading ? "Loading access points..." :"No access points found."}
          scrollable scrollHeight="80vh" stripedRows resizableColumns columnResizeMode="fit">

              <Column field="tile" header="Tile"></Column>
              <Column field="gate" header="Gate" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} 
                sortable></Column>
              <Column field="size" header="Size"></Column>
              <Column field="colour" header="Colour"></Column>
              <Column field="checkIn" header="Check In"></Column>
              <Column field="type" header="Type"></Column>
              <Column field="comments" header="Comments"></Column>
              <Column field="scanType" header="ScanType"></Column>
              <Column field="quantity" header="Quantity" sortable></Column>
              <Column header="Edit" body={editBodyTemplate} headerStyle={{ width: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>

          </DataTable>
              
          </div>
          <div>
            <p className='mt-3'>Type: It is either Tile, AccessPod, TilePodMini, TilePodMini with Backboard or TilePod</p>
            <p className='mt-3'>ScanType: It is either Access, Member Information or Check-in</p>
            <p className='mt-3'>Tile sizes: 55x61mm; 65x72mm; 85x94mm; 110x122mm; A4; A5; A3; Tile Wedge; Round; Standard</p>
          </div>

                  <OverlayPanel ref={op}>
            {startContent}
          </OverlayPanel>
        <ScrollTop />
      </Container>
    
  );
};

export default ReplacementTiles;
